import React from 'react';
import { string, shape, arrayOf, number } from 'prop-types';

import { useBLazyRevalidate } from 'hooks';
import { VideoCard } from 'components/cards';
import { LISTING_CONTAINER_ID } from '../constants';

const VideosListing = ({ items }) => {
    useBLazyRevalidate(LISTING_CONTAINER_ID, [items]);

    if (!items || !items.length) {
        return null;
    }

    return (
        <div className="grid grid--cards grid--equal-height grid--cards--large-v-gutter">
            {items.map(item => (
                <div className="col-lg-4 col-sm-6" key={item.id}>
                    <VideoCard {...item} />
                </div>
            ))}
        </div>
    );
};

VideosListing.propTypes = {
    items: arrayOf(
        shape({
            badges: arrayOf(
                shape({
                    bgColor: string,
                    color: string,
                    id: string,
                    title: string
                })
            ),
            buttonTitle: string.isRequired,
            url: string.isRequired,
            target: string,
            thumbnailAlt: string,
            estimate: string.isRequired,
            language: string.isRequired,
            date: string.isRequired,
            dateTitle: string.isRequired,
            filesCount: number,
            filesTitle: string,
            description: string.isRequired,
            title: string.isRequired,
            videoId: string.isRequired
        })
    ).isRequired
};

export default VideosListing;
